// Step back
// Determines which step the user is on and shows the previous
// step in the form flow if available.
// ----------------------------------------------------------------

import $ from 'jquery';

import { focusFirstFieldsetInput } from '../focus-first-fieldset-input';
import { formProgressTracker } from './form-progress-tracker';

export function stepBack(fieldset) {

    // Hides current fieldset.
    fieldset.hide();

    // Gets the current step value and sets next step value.
    var step = parseInt(fieldset.attr('data-donation-form-step'));
    var previousStep = step - 1;

    // Shows the fieldset of the previous step.
    $(fieldset).closest('.js-donationForm').find('fieldset[data-donation-form-step="' + previousStep + '"]').show();

    // Update form progress tracker
    formProgressTracker(fieldset, previousStep);

    // Focus first input of previous step.
    focusFirstFieldsetInput(previousStep);


    // TODO: Refactor following for step-continue and step-back
    // Animate scrolling to next element if viewport is "md" breakpoint or lower
    // or if mobile persistence is forced.
    if (
        $(window).width() < 1024 ||
        $(fieldset).closest('.js-donationForm').hasClass('js-donationFormPersistMobile')
    ) {
        // Some forms may have the step buttons hidden in favour of only forward/backward buttons.
        // If so then scroll to the first visible fieldset within the form.
        if ($('.js-formStepTrigger').is(':visible')) {

            // donation-form-v2 may not have button available
            if ($(fieldset).next().is('button')) {
                $('html, body').animate({
                    scrollTop: $(fieldset).next('button').offset().top
                });

            } else if ($(fieldset).next().is('fieldset')) {
                $('html, body').animate({
                    scrollTop: $(fieldset).closest('.js-donationForm').offset().top
                });

            }

        } else {
            $('html, body').animate({
                scrollTop: $(fieldset).closest('.js-donationForm').find('fieldset:visible').offset().top
            });

        }
    }

}
